import { authRoles } from 'app/auth';
import SpreadsheetModelEditForm from './editform/SpreadsheetModelEditForm';

export default [
	{
		path: '/model-spreadsheet/edit/:id/:driverName?',
		component: SpreadsheetModelEditForm,
		auth: authRoles.model
	}
];
